export default {
  title: {
    id: 'bundle_modal_title',
    defaultMessage: 'Often bought together',
  },
}
